import { faker } from '@faker-js/faker'

import { NonBusinessDay } from '../../contracts/reservation'
import { asBuilder } from '../asBuilder'

export const getNonBusinessDays = asBuilder<NonBusinessDay[]>((): NonBusinessDay[] => {
  return faker.helpers.multiple(
    () => ({
      date: faker.date.recent().toISOString().split('T')[0],
      isNonBusinessDay: faker.datatype.boolean(),
    }),
    { count: 7 },
  )
})
